const {
  ACCESSIBILITY_TESTING_MOUNT_POINT,
  APPS_PAGES_MOUNT_POINT,
  APP_DIRECTORY_PAGES_MOUNT_POINT,
  COMPANIES_PAGES_MOUNT_POINT,
  CUSTOMERS_PAGES_MOUNT_POINT,
  HELPDOCS_MOUNT_POINT,
  PATHS_MOUNT_POINT,
  PARTNER_MOUNT_POINT,
  PRESS_PAGES_MOUNT_POINT,
  PRICING_PAGES_MOUNT_POINT,
  PLATFORM_CONTENT_SITE_MOUNT_POINT,
  SANDBOX_MOUNT_POINT,
} = require('../constants');

const routes = require('next-routes')();

const route = options => {
  if (typeof options.name !== 'string') {
    throw new Error(
      'next-routes route definitions must have a "name" property.'
    );
  }

  if (typeof options.pattern !== 'string') {
    throw new Error(
      'next-routes route definitions must have a "pattern" property.'
    );
  }

  if (typeof options.page !== 'string') {
    throw new Error(
      'next-routes route definitions must have a "page" property.'
    );
  }

  return options;
};

routes
  .add({
    name: 'companies',
    pattern: `/${COMPANIES_PAGES_MOUNT_POINT}`,
    page: '/companies',
  })
  .add({
    name: 'customers',
    pattern: `/${CUSTOMERS_PAGES_MOUNT_POINT}`,
    page: '/customers/index',
  })
  .add({
    name: 'helpdocs-content',
    pattern: `/${HELPDOCS_MOUNT_POINT}/:category/:subcategory/:content`,
    page: '/helpdocs/content',
  })
  .add({
    name: 'helpdocs-subcategory',
    pattern: `/${HELPDOCS_MOUNT_POINT}/:category/:subcategory`,
    page: '/helpdocs/subcategory',
  })
  .add({
    name: 'helpdocs-search',
    pattern: `/${HELPDOCS_MOUNT_POINT}/search`,
    page: '/helpdocs/search',
  })
  .add({
    name: 'helpdocs-category',
    pattern: `/${HELPDOCS_MOUNT_POINT}/:category`,
    page: '/helpdocs/category',
  })
  .add({
    name: 'helpdocs',
    pattern: `/${HELPDOCS_MOUNT_POINT}`,
    page: '/helpdocs/index',
  })
  .add({
    name: 'platform-content-site-home',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}`,
    page: '/platform/content-site/home',
  })
  .add({
    name: 'platform-content-site-how-to-build',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/how-to-build`,
    page: '/platform/content-site/how-to-build',
  })
  .add({
    name: 'platform-content-site-partner-program',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/partner-program`,
    page: '/platform/content-site/partner-program',
  })
  .add({
    name: 'platform-content-site-tos',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/tos`,
    page: '/platform/content-site/tos',
  })
  .add({
    name: 'platform-content-site-acceptable-use',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/acceptable-use`,
    page: '/platform/content-site/acceptable-use',
  })
  .add(
    route({
      name: 'pricing',
      pattern: `/${PRICING_PAGES_MOUNT_POINT}`,
      page: '/pricing',
    })
  )
  .add(
    route({
      name: 'webssr-gopt',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/webssr-gopt`,
      page: '/apps/webssr-gopt',
    })
  )
  .add(
    route({
      name: 'fastest-growing-apps',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/fastest-growing-apps`,
      page: '/apps/fastest-growing-apps',
    })
  )
  .add(
    route({
      name: 'app-overview',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug`,
      page: '/apps/app-overview',
    })
  )
  .add(
    route({
      name: 'app-integrations',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/integrations`,
      page: '/apps/app-integrations',
    })
  )
  .add(
    route({
      name: 'app-alternatives',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/alternatives`,
      page: '/apps/app-alternatives',
    })
  )
  .add(
    route({
      name: 'app-media',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/media`,
      page: '/apps/app-media',
    })
  )
  .add(
    route({
      name: 'app-integrations-landing',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/landing`,
      page: '/apps/app-integrations-landing',
    })
  )
  .add(
    route({
      name: 'app-integrations-roles',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/roles/:role`,
      page: '/apps/app-integrations-roles-landing',
    })
  )
  .add(
    route({
      name: 'app-integrations-roles-landing',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/roles/:role/landing`,
      page: '/apps/app-integrations-roles-landing',
    })
  )
  .add(
    route({
      name: 'app-tutorial-list',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/tutorials`,
      page: '/apps/app-tutorial-list',
    })
  )
  .add(
    route({
      name: 'app-tutorial-details',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/tutorials/:blogSlug`,
      page: '/apps/app-tutorial-details',
    })
  )
  .add(
    route({
      name: 'app-help',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/help`,
      page: '/apps/app-help',
    })
  )
  .add(
    route({
      name: 'app-updates',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:slug/updates`,
      page: '/apps/app-updates',
    })
  )
  .add(
    route({
      name: 'two-app-integrations',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:primarySlug/integrations/:secondarySlug`,
      page: '/apps/two-app-integrations',
    })
  )
  .add(
    route({
      name: 'two-app-integrations-landing',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:primarySlug/integrations/:secondarySlug/landing`,
      page: '/apps/two-app-integrations-landing',
    })
  )
  .add(
    route({
      name: 'zap-template',
      pattern: `/${APPS_PAGES_MOUNT_POINT}/:primarySlug/integrations/:secondarySlug/:zapId/:zapSlug`,
      page: '/apps/zap-template',
    })
  )
  .add(
    route({
      name: 'paths',
      pattern: `/${PATHS_MOUNT_POINT}`,
      page: '/paths/index',
    })
  )
  .add(
    route({
      name: 'press-index',
      pattern: `/${PRESS_PAGES_MOUNT_POINT}`,
      page: '/press/index',
    })
  )
  .add(
    route({
      name: 'partner-confirm-profile',
      pattern: `/${PARTNER_MOUNT_POINT}/confirm-profile`,
      page: '/partners/confirm-profile',
    })
  )
  .add(
    route({
      name: 'app-directory-overview',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:slug`,
      page: '/app-directory/app-directory-overview',
    })
  )
  .add(
    route({
      name: 'app-directory-one-app-integrations',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:slug/integrations`,
      page: '/app-directory/app-directory-one-app-integrations',
    })
  )
  .add(
    route({
      name: 'app-directory-two-app-integrations',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:primarySlug/integrations/:secondarySlug`,
      page: '/app-directory/app-directory-two-app-integrations',
    })
  )
  .add(
    route({
      name: 'app-directory-zap-template',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:primarySlug/integrations/:secondarySlug/:zapId/:zapSlug`,
      page: '/app-directory/app-directory-zap-template',
    })
  )
  .add(
    route({
      name: 'app-directory-alternatives',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:slug/alternatives`,
      page: '/app-directory/app-directory-alternatives',
    })
  )
  .add(
    route({
      name: 'app-directory-help',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:slug/help`,
      page: '/app-directory/app-directory-help',
    })
  )
  .add(
    route({
      name: 'app-directory-tutorial-list',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:slug/tutorials`,
      page: '/app-directory/app-directory-tutorial-list',
    })
  )
  .add(
    route({
      name: 'app-directory-tutorial-details',
      pattern: `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/:slug/tutorials/:blogSlug`,
      page: '/app-directory/app-directory-tutorial-details',
    })
  )
  .add(
    route({
      name: 'sandbox',
      pattern: `/${SANDBOX_MOUNT_POINT}`,
      page: '/sandbox/sandbox',
    })
  )
  .add(
    route({
      name: 'accessibility-testing',
      pattern: `/${ACCESSIBILITY_TESTING_MOUNT_POINT}`,
      page: '/accessibility-testing/index',
    })
  );

const IS_XFRAMES_EXEMPT = Symbol('isXFramesExempt');

function addXFrameExemptRoute(options) {
  routes.add(route(options));

  Object.defineProperty(routes.findByName(options.name), IS_XFRAMES_EXEMPT, {
    value: true,
    enumerable: false,
  });
}

function isRouteXFrameExempt(currentRoute) {
  return !!(currentRoute && currentRoute[IS_XFRAMES_EXEMPT]);
}

addXFrameExemptRoute({
  name: 'partner-template-view',
  pattern: `/${PARTNER_MOUNT_POINT}/:integrationId/embed/:templateId/:templateSlug`,
  page: '/partners/template-view',
});

module.exports = {
  routes,
  isRouteXFrameExempt,
};
